$(function() {
  if ($('.flash-alert').length > 0) {
    $(".flash-alert").alert();
    window.setTimeout(function() {
      $("#alert-wrap .alert").alert('close');
    }, 3000);
  }
});
